import { Dict } from '../../../model/dict';

export function toIdDict<T extends { id: string }>(array: T[]): Dict<T> {
  return array.reduce((dict: Dict<T>, item: T) => {
    dict[item.id] = item;
    return dict;
  }, {});
}
